module.exports = __webpack_public_path__ + "9489f5e88ba1cbfa14b5bbb2f85fb5a2.ttf";